import { render } from "./VideoDialog.vue?vue&type=template&id=1d650f60&scoped=true"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"

import "./VideoDialog.vue?vue&type=style&index=0&id=1d650f60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d650f60"]])

export default __exports__